// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class TabAccordion extends Component {
  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement) {
    super.bind(pEl);
    this.addListener(Notifications.CHANGE_TAB, this.onChange);
  }

  /**
   * Executes when a tab changes
   */
  onChange(pData: Object): void {
    this.el.style.height = pData.height;
  }
}
